import { AccessGate, AccessProvider } from "@drs-ops/access/frontend";
import type React from "react";
import { useAuth } from "@/auth";
import { SignIn } from "@/pages/SignIn";

/**
 * Signed in (Entra) → allowed in this app (@drs-ops/access: pending / disabled screens) → the app.
 * `onSignOut` puts Sign out on the gate's error, Pending and Disabled screens, which clears the MSAL
 * cache so a stale or rejected token can't trap the user there.
 */
export function AuthGate({ children }: { children: React.ReactNode }): React.ReactElement {
  const { isAuthenticated, isLoading, authorizedFetch, logout } = useAuth();
  if (isLoading)
    return <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">Loading…</div>;
  if (!isAuthenticated) return <SignIn />;
  return (
    <AccessProvider fetchImpl={authorizedFetch}>
      <AccessGate appName="Estimator" onSignOut={logout}>
        {children}
      </AccessGate>
    </AccessProvider>
  );
}
